import React from 'react';
import { PARENT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { GetIconFunction } from '../../../icon/types.tsx';
import { HierarchyIcon } from './hierarchy-icon/index.tsx';

export const getParentIcon: GetIconFunction = () => ({
	[PARENT_TYPE]: <HierarchyIcon />,
});
